import { ShareArgs } from './share-args'

export module ShareLinks {

  export function facebookShare(args: ShareArgs) {
    let shareUrl = 'https://www.facebook.com/sharer/sharer.php'
    shareUrl += `?u=${args.url}`

    if (args.title) {
      shareUrl += `&title=${args.title}`
    }

    if (args.description) {
      shareUrl += `&description=${args.description}`
    }

    if (args.image) {
      shareUrl += `&image=${args.image}`
    }

    return shareUrl
  }

  export function twitterShare(args: ShareArgs) {
    let shareUrl = 'https://twitter.com/intent/tweet'
    shareUrl += `?url=${args.url}`

    if (args.title) {
      shareUrl += `&title=${args.title}`
    }

    if (args.via) {
      shareUrl += `&via=${args.via}`
    }

    if (args.tags) {
      shareUrl += `&tags=${args.tags}`
    }

    return shareUrl
  }

  export function googlePlusShare(args: ShareArgs) {
    return `https://plus.google.com/share?url=${args.url}`
  }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/social-share/shared/share-links.functions.ts